<template>
    <div class="baizhi">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p>
                        <span>百智</span><span>债券风险管理BI平台</span>
                    </p>
                    <p>
                       债券是固定收益类产品中最为重要的投资标的。债券具有收益中等，风险较小的特点，深受投资者青睐。我们建立了百智债券风险管理BI平台，主要提供债券基本要素展示、发债主体信用评级的功能。
                    </p>
                </div>

            </div>
        </div>
        
        <div class="two">
            <div class="text">
                <p>基本要素信息展示模块</p>
                <p>
                    基于用户输入的债券代码或名称，输出相应的债券基本要素信息。债券分类更详细，查询更便捷。
                </p>
            </div>
            <img src="../assets/baizhi-back-two.png"
     srcset="../assets/baizhi-back-two@2x.png 2x,
             ../assets/baizhi-back-two@3x.png 3x" class="two-img">
        </div> 
        <div class="three-wrap">
            <div class="three">
                <div class="text">
                    <p>主体信用评价分析模块</p>
                    <p>
                        挖掘发行主体深度资料，借助量化分析方法，考虑多种维度因素，自行研发行业打分模型，对发债主体信用状况进行客观评价。
                    </p>
                </div>
                <img src="../assets/baizhi-back-three.png"
        srcset="../assets/baizhi-back-three@2x.png 2x,
                ../assets/baizhi-back-three@3x.png 3x" class="three-img">
            </div> 
        </div>

        
        <div class="four">
            <div class="text">
                <p>全网债券新闻文本数据库</p>
                <p>
                    打造金融债券数据库，监控债券舆情新闻，公告、新闻一站解决。
                </p>
            </div>
            <img src="../assets/baizhi-back-four.jpg"
    srcset="../assets/baizhi-back-four@2x.jpg 2x,
            ../assets/baizhi-back-four@3x.jpg 3x" class="two-img">
        </div> 
        
        
    </div>
</template>
<script>
export default {
    name: 'baizhi'
}
</script>

<style lang="scss">
.baizhi{
    min-width: 1000px;
    .first{
        min-height: 280px;
        background: url("../assets/baizhi-back-first.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/baizhi-back-first@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/baizhi-back-first@3x.jpg") no-repeat center/cover;
        }

        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            .text{
                width: 657px;
                margin: 0 auto;
                margin-top: 95px;
                text-align: center;
                p:nth-child(1){
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1.5;
                    margin-bottom: 24px;
                    span:nth-child(1){
                        color:#fcc617
                    }
                }
                p:nth-child(2){
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
        }
    }
    .two,.three,.four{
        width: 1000px;
        margin: 0 auto;
        .text{
            float: left;
            width: 309px;
            margin-top: 178px;
            p:nth-child(1){
                font-size: 30px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: normal;
                color: #064ec1;
                margin-bottom: 17px;
            }
            p:nth-child(2){
                font-size: 14px;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.86;
                letter-spacing: normal;
                color: #000;
            }
        }
    }
    .two,.four{
        height: 496px;
        .two-img{
            float: right;
        }
    }
    .three-wrap{
        background-color: #dfe1ed;
        height: 487px;
        width: 100%;
    }
    .three{
        .text{
            float: right;
        }
        .three-img{
            float: left;
            margin-top: 56px;
        }
    }
    .four{
        height: 505px;
        .text{
            width: 330px;
        }
        .two-img{
            margin-top: 27px;
        }
    }
}
</style>